import React from 'react';

import { Combobox, ComboboxContent, ComboboxEmpty, ComboboxInput, ComboboxItem, ComboboxList } from '@column/ui';

interface EventTypeComboboxProps {
  value: string;
  onValueChange: (value: string) => void;
  eventTypes: string[];
  className?: string;
}

// Searchable single-select over webhook event types, used to pick the event a test send fires.
export const EventTypeCombobox: React.FC<EventTypeComboboxProps> = ({
  value,
  onValueChange,
  eventTypes,
  className,
}) => (
  <Combobox items={eventTypes} value={value || null} onValueChange={(next: string | null) => onValueChange(next ?? '')}>
    <ComboboxInput placeholder="Select event type" className={className} />
    <ComboboxContent>
      <ComboboxEmpty>No event types found.</ComboboxEmpty>
      <ComboboxList>
        {(eventType: string) => (
          <ComboboxItem key={eventType} value={eventType}>
            {eventType}
          </ComboboxItem>
        )}
      </ComboboxList>
    </ComboboxContent>
  </Combobox>
);
